import axios from 'axios';

const BFF_BASE_ADDRESS = process.env.REACT_APP_BFF_BASE_ADDRESS || 'https://localhost:7181';

const httpClient = axios.create({ baseURL: BFF_BASE_ADDRESS });

httpClient.interceptors.request.use((config) => {
    const token = sessionStorage.getItem('backofficeToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

httpClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            sessionStorage.removeItem('backofficeToken');
            sessionStorage.removeItem('backofficeUsername');
            window.location.href = '/login';
            // A página já está navegando pra fora — não deixa o catch de cada componente
            // rodar e mostrar "Request failed with status code 401" antes do redirect completar.
            return new Promise(() => {});
        }
        return Promise.reject(error);
    }
);

export const extractErrorMessage = (error) =>
    error.response?.data?.Message || error.response?.data?.message || error.message || 'Ocorreu um erro inesperado.';

export default httpClient;
